import { Action } from 'redux';
import { Currency } from 'src/types/model';

export interface CurrencyState {
  loading: boolean;
  data: any;
  error: string | null;
}

export const FETCH_CURRENCY_REQUEST = 'FETCH_CURRENCY_REQUEST';
export const FETCH_CURRENCY_SUCCESS = 'FETCH_CURRENCY_SUCCESS';
export const FETCH_MY_CURRENCY_SUCCESS = 'FETCH_MY_CURRENCY_SUCCESS';
export const FETCH_CURRENCY_FAILURE = 'FETCH_CURRENCY_FAILURE';

export interface FetchCurrencyRequestAction
  extends Action<typeof FETCH_CURRENCY_REQUEST> {}

export interface FetchCurrencySuccessAction
  extends Action<typeof FETCH_CURRENCY_SUCCESS> {
  payload: Currency[];
}

export interface FetchMyCurrencySuccessAction
  extends Action<typeof FETCH_MY_CURRENCY_SUCCESS> {
  payload: Currency;
}

export interface FetchCurrencyFailureAction
  extends Action<typeof FETCH_CURRENCY_FAILURE> {
  payload: string;
}

export type CurrencyActionType =
  | FetchCurrencyRequestAction
  | FetchCurrencySuccessAction
  | FetchMyCurrencySuccessAction
  | FetchCurrencyFailureAction;
